// 板材サイズ入力コンポーネント

interface VeneerInputProps {
  title: string;
  width: string;
  height: string;
  allowRotation: boolean;
  onWidthChange: (value: string) => void;
  onHeightChange: (value: string) => void;
  onRotationChange: (value: boolean) => void;
  widthError?: string;
  heightError?: string;
  widthTouched?: boolean;
  heightTouched?: boolean;
}

export function VeneerInput({
  title,
  width,
  height,
  allowRotation,
  onWidthChange,
  onHeightChange,
  onRotationChange,
  widthError,
  heightError,
  widthTouched,
  heightTouched,
}: VeneerInputProps) {
  const showWidthError = widthError && widthTouched;
  const showHeightError = heightError && heightTouched;

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-gray-900">{title}</h3>
      
      <div className="grid grid-cols-2 gap-4">
        <div className="form-group">
          <label htmlFor={`${title.toLowerCase()}-width`} className="form-label">
            幅 (mm)
            <span className="text-red-600 ml-1" aria-label="必須">*</span>
          </label>
          
          <input
            type="number"
            id={`${title.toLowerCase()}-width`}
            value={width}
            onChange={(e) => onWidthChange(e.target.value)}
            className={`input-field ${showWidthError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}`}
            placeholder="900"
            min="1"
            step="1"
            aria-invalid={showWidthError ? 'true' : undefined}
            aria-describedby={showWidthError ? `${title.toLowerCase()}-width-error` : undefined}
          />

          {showWidthError && (
            <div id={`${title.toLowerCase()}-width-error`} className="form-error" role="alert">
              {widthError}
            </div>
          )}
        </div>

        <div className="form-group">
          <label htmlFor={`${title.toLowerCase()}-height`} className="form-label">
            高さ (mm)
            <span className="text-red-600 ml-1" aria-label="必須">*</span>
          </label>
          
          <input
            type="number"
            id={`${title.toLowerCase()}-height`}
            value={height}
            onChange={(e) => onHeightChange(e.target.value)}
            className={`input-field ${showHeightError ? 'border-red-500 focus:border-red-500 focus:ring-red-500' : ''}`}
            placeholder="1800"
            min="1"
            step="1"
            aria-invalid={showHeightError ? 'true' : undefined}
            aria-describedby={showHeightError ? `${title.toLowerCase()}-height-error` : undefined}
          />

          {showHeightError && (
            <div id={`${title.toLowerCase()}-height-error`} className="form-error" role="alert">
              {heightError}
            </div>
          )}
        </div>
      </div>

      <div className="flex items-center p-2 cursor-pointer hover:bg-gray-50 rounded-lg transition-colors duration-150">
        <input
          type="checkbox"
          id={`${title.toLowerCase()}-rotation`}
          checked={!allowRotation}
          onChange={(e) => onRotationChange(!e.target.checked)}
          className="h-5 w-5 text-blue-600 focus:ring-blue-500 border-gray-300 rounded shadow-sm"
        />
        <label htmlFor={`${title.toLowerCase()}-rotation`} className="ml-2 text-sm text-gray-900 cursor-pointer">
          回転不可
        </label>
      </div>
    </div>
  );
}